import makeApiCall from "../master/axiosIndex";

const dropdownApis = {
  getProjectsDropdown: (siteIds: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/project/dropdown`,
      params: { siteIds },
    }),
  fetchContractorsBySiteIdDropdown: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/buyer/fetchContractorBySiteId`,
      data,
    }),
  materialBOQDropDown: (siteIds: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/inventory/consumptionTarget/dropdown`,
      params: { siteIds, remainingRequestedQty: true },
    }),
  workCategoryDropDown: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/masters/workCatgoriesList`,
    }),
  materialBoQMaterialLinesDrioDown: (
    targetId: number,
    params?: {
      siteStructureUnitId?: number;
      floorNo?: string;
      siteStructureSubUnitId?: number;
      locationId?: number;
    }
  ): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/inventory/consumptionTarget/boq-lines-by-site-structure`,
      params: { targetId, ...params, groupByBoqLine: true },
    }),
  workUomDropDown: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/masters/workUomsList`,
    }),
  fetchBlockBySiteId: (id: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchBlockById`,
      params: { id },
    }),
  fetchActivityDropdown: (projectId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/activity/dropdown`,
      params: { projectId },
    }),
  fetchContractorDropDown: (partyType?: string): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchContractorDropDown`,
      params: partyType ? { partyType } : {},
    }),
  fetchWorkOrderDropdown: (flowType: string): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/work-order/dropdown`,
      params: { flowType },
    }),
  fetchRABillDropdown: (flowType: string): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/ra-bill/dropdown`,
      params: { flowType },
    }),
  fetchTaxDropdown: (taxType?: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchTaxDropDown`,
      params: { taxType: taxType },
    }),
  getBudgetDropdownBySiteId: (siteId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/budget/dropdown`,
      params: { siteIds: siteId },
    }),
  getBudgetLinesDropdown: (headerId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/budget/linesDropdown`,
      params: {
        headerId: headerId,
        bom: "N",
      },
    }),
  getStatesByCountry: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/misc/stateByCountry`,
      params: { countryId: 1 },
    }),
  fetchSiteStructureUnitsBySiteId: (siteId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchSiteStructureUnitsBySiteId`,
      params: { siteId },
    }),
  fetchFloorNumbersByUnitId: (siteId: number, unitId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchFloorNumbersByUnitId`,
      params: { siteId, unitId },
    }),
  fetchFlatsBySiteIdUnitIdFloor: (
    siteId: number,
    unitId: number,
    floorNo: string
  ): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchSiteStructureSubUnitsByUnitId`,
      params: { siteId, unitId, floorNo },
    }),
  fetchLocationsBySiteId: (siteId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchLocationsBySiteId`,
      params: { siteId },
    }),
  fetchSegmentLevelBySiteId: (siteId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchSegmentLevelBySiteId`,
      params: { siteId },
    }),
  fetchUserDropdown: (siteIds?: string): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchUserDropdown`,
      params: siteIds ? { siteIds } : {},
    }),
};

export default dropdownApis;
